<div class="sponsors-area pb-100" *ngIf="logos && logos.length > 0">
    <div class="container-fluid">
        <div class="section-title-center">
            <h2>Nos partenaires</h2>
            <p>Ils nous accompagnent pour faire émerger les solutions technologiques africaines de demain.</p>
        </div>  
  
      <div class="sponsors-carousel">
        <owl-carousel-o [options]="sponsorsSlides">
          <ng-container *ngFor="let logo of logos">
            <ng-template carouselSlide>
              <div class="sponsor-slide-item">
                <img [src]="logo" alt="Sponsor Logo" class="img-fluid">
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>
  </div>
  